//@flow
import React, {useState} from 'react';

import {makeStyles, ButtonBase, Typography} from '@material-ui/core';
import {colors} from '../../../../../../../assets/styles/colors';
import CustomModal from '../../../../../../../elements/CustomModal/CustomModal';
import OpenConversationForm from './OpenConversationForm';
import {useToggle} from '../../../../../../../utils/react';
import {useStoreDevices} from '../../../../utils';
import TiendadaRadioButton from '../../../../../../../elements/tiendada-radio-button';
import OpenWhatsappBusinessConversation from './OpenWhatsappBusinessConversation';
import {useIsFeatureInTier} from '../../../../../../../utils/component';

const useStyles = makeStyles(theme => ({
  openConversationButton: {
    width: '100%',
    padding: '1rem',
    background: colors.lightPurple,
    color: colors.grey900,
    textTransform: 'none',
    fontWeight: 600,
  },
  modalOptions: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  modalTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    color: colors.grey900,
  },
}));

export default function OpenConversation() {
  const classes = useStyles();

  const [modalOpen, toggleModalOpen] = useToggle();

  const {storeDevices} = useStoreDevices();

  const hasWhatsappApiFeature = useIsFeatureInTier('TIENDACHAT_WHATSAPP_API');

  const [typeSelected, setTypeSelected] = useState(
    hasWhatsappApiFeature ? undefined : 'WHATSAPP_WEB'
  );

  const shouldShowOpenConversation = storeDevices.some(
    device =>
      (device.service === 'WHATSAPP_WEB' && device.state === 'CONNECTED') ||
      (device.service === 'WHATSAPP_API' && device.state === 'CONNECTED')
  );

  if (!shouldShowOpenConversation) {
    return null;
  }

  const handleCloseConversations = () => {
    setTypeSelected('');
    toggleModalOpen();
  };

  return (
    <div>
      <ButtonBase
        className={classes.openConversationButton}
        onClick={toggleModalOpen}
      >
        Nueva Conversación
      </ButtonBase>
      <CustomModal open={modalOpen} onClose={handleCloseConversations}>
        {!typeSelected && (
          <div className={classes.modalContent}>
            <Typography className={classes.modalTitle}>
              Seleccionar el tipo de dispositivo
            </Typography>
            <div className={classes.modalOptions}>
              <TiendadaRadioButton
                name="device-type"
                label="WhatsApp Web"
                onChange={() => setTypeSelected('WHATSAPP_WEB')}
                description="Inicia una conversación con whatsapp web"
              />
              {hasWhatsappApiFeature && (
                <TiendadaRadioButton
                  name="device-type"
                  label="WhatsApp Api"
                  onChange={() => setTypeSelected('WHATSAPP_API')}
                  description="Inicia una conversación con whatsapp Api"
                />
              )}
            </div>
          </div>
        )}
        {typeSelected === 'WHATSAPP_API' && (
          <OpenWhatsappBusinessConversation
            onSubmitSuccess={handleCloseConversations}
          />
        )}

        {typeSelected === 'WHATSAPP_WEB' && (
          <OpenConversationForm onSubmitSuccess={handleCloseConversations} />
        )}
      </CustomModal>
    </div>
  );
}
